import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35bed2a7&scoped=true&"
var script = {}
import style0 from "./style.sass?vue&type=style&index=0&id=35bed2a7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bed2a7",
  null
  
)

export default component.exports